export default "__VITE_ASSET__a7603963__"